export default "__VITE_ASSET__cghNjmhY__"